<template>
  <div class="page-account">
    <div class="container">
      <el-breadcrumb class="hsb-breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.name==='Coupon'">我的现金券</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.name==='OrderList'">我的订单</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.name==='AccountManage'">账户管理</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.name==='Wallet'">我的钱包</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="side">
        <div class="panel">
          <h3 class="panel-hd">我的账户</h3>
          <div class="panel-bd">
            <router-link
              class="link"
              :class="{'is-active': $route.name === 'AccountManage'}"
              to="/Account"
            >
              <span>账户管理</span>
            </router-link>
            <router-link
              class="link"
              :class="{'is-active': $route.name === 'Wallet'}"
              to="/Account/Wallet"
            >
              <span>我的钱包</span>
            </router-link>
            <router-link
              class="link"
              :class="{'is-active': $route.name === 'OrderList'}"
              to="/Account/OrderList"
            >
              <span>我的订单</span>
            </router-link>
            <router-link
              class="link"
              :class="{'is-active': $route.name === 'Coupon'}"
              to="/Account/Coupon"
            >
              <span>我的现金券</span>
            </router-link>
          </div>
        </div>
        <!-- <div class="panel">
          <h3 class="panel-hd">客服服务</h3>
          <div class="panel-bd">
            <p>客服电话：400-080-9966</p>
            <p>服务时间：9:00-19:00</p>
          </div>
        </div> -->
        <div class="panel">
          <h3 class="panel-hd">回收宝邮寄地址</h3>
          <div class="panel-bd">
            <p>深圳市 福田区 华强北曼哈商业广场A座3楼（回收宝收）</p>
            <p>Tel: 18123877635</p>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="main-inner">
          <h3 class="title">{{ $route.meta.title }}</h3>
          <router-view></router-view>
        </div>
      </div>
    </div>
    <Sidebar></Sidebar>
  </div>
</template>

<script>
import { Breadcrumb, BreadcrumbItem } from 'element-ui';
import Sidebar from '../../components/sidebar';
export default {
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    Sidebar
  }
};
</script>

<style scoped>
@import 'config.css';
.side {
  float: left;
  width: 285px;
}
.panel {
  width: 100%;
  height: 184px;
  margin-bottom: 10px;
  background-color: #fff;
}
.panel-hd {
  padding-top: 24px;
  padding-left: 30px;
  padding-bottom: 20px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 400;
}
.panel-bd {
  padding-left: 50px;
  padding-right: 20px;
  color: #999;
  font-size: 14px;
  line-height: 24px;
}
a {
  display: block;
}
.main {
  float: left;
  width: 820px;
  min-height: 582px;
  margin-left: 10px;
  background-color: #fff;
  &-inner {
    padding: 0 40px;
    padding-top: 24px;
  }
}
.link {
  color: #999;
  font-size: 14px;
  &:hover,
  &.is-active {
    color: $active-a-color;
  }
}
.title {
  margin-bottom: 30px;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/account/index.vue